(function () {
  'use strict';

  function openCartDrawer(trigger) {
    var drawer =
      document.querySelector('hdt-cart-drawer#CartDrawer') ||
      document.querySelector('hdt-cart-drawer') ||
      document.querySelector('cart-drawer');

    if (drawer && typeof drawer.openDialog === 'function') {
      drawer.openDialog();
      return;
    }
    if (drawer && typeof drawer.open === 'function') {
      drawer.open(trigger);
      return;
    }

    var cartBtn =
      document.querySelector('#cart-icon-bubble[aria-controls="CartDrawer"]') ||
      document.querySelector('[aria-controls="CartDrawer"]');
    if (cartBtn) {
      cartBtn.click();
      return;
    }

    window.location.href = (trigger && trigger.getAttribute('href')) || '/cart';
  }

  function readHeaderCartCount() {
    var hdtCount = document.querySelector('hdt-cart-count');
    if (hdtCount) {
      return parseInt(hdtCount.textContent, 10) || 0;
    }
    var headerCount = document.querySelector('#CartCount');
    if (!headerCount) return null;
    return parseInt(headerCount.textContent, 10) || 0;
  }

  function syncPdpCartCount(count) {
    var resolvedCount = typeof count === 'number' ? count : readHeaderCartCount();
    if (resolvedCount === null) return;

    document.querySelectorAll('[data-pdp-cart-count]').forEach(function (badge) {
      badge.textContent = resolvedCount;
    });

    document.querySelectorAll('.pdp-revamp__cart-btn').forEach(function (button) {
      button.classList.toggle('has-items', resolvedCount > 0);
    });
  }

  function watchHeaderCartCount() {
    var headerCount =
      document.querySelector('hdt-cart-count') || document.querySelector('#CartCount');
    if (!headerCount || headerCount.dataset.pdpCartWatch === 'true') return;
    headerCount.dataset.pdpCartWatch = 'true';

    syncPdpCartCount(readHeaderCartCount());

    var observer = new MutationObserver(function () {
      syncPdpCartCount(readHeaderCartCount());
    });

    observer.observe(headerCount, {
      childList: true,
      characterData: true,
      subtree: true,
    });
  }

  function initCartShortcut(root) {
    if (!root || root.dataset.pdpAtcInit === 'true') return;
    root.dataset.pdpAtcInit = 'true';

    root.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-pdp-cart-open]');
      if (!trigger || !root.contains(trigger)) return;
      event.preventDefault();
      openCartDrawer(trigger);
    });
  }

  function initAll(scope) {
    var context = scope || document;
    context.querySelectorAll('.pdp-revamp__atc').forEach(initCartShortcut);
    watchHeaderCartCount();
    syncPdpCartCount();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  document.addEventListener('cart:updated', function (event) {
    if (event.detail && typeof event.detail.item_count === 'number') {
      syncPdpCartCount(event.detail.item_count);
    } else {
      syncPdpCartCount();
    }
  });

  document.addEventListener('cart:change', function (event) {
    if (event.detail && event.detail.cart && typeof event.detail.cart.item_count === 'number') {
      syncPdpCartCount(event.detail.cart.item_count);
    } else {
      syncPdpCartCount();
    }
  });
})();
